<template>
  <RouterLink
    v-if="props.result"
    :to="{ name: 'settings' }"
    :class="$style.link"
  >
    <p :class="$style.link__name">{{ props.result?.profile.name }}</p>
    <p :class="$style.link__email">{{ props.result?.staff.email }}</p>
  </RouterLink>
</template>

<script setup lang="ts">
import type { AppHeaderSettingLinkViewerFragment } from './AppHeaderSettingLink.generated'

const props = defineProps<{
  result: AppHeaderSettingLinkViewerFragment | null
}>()
</script>

<style lang="scss" module>
.link {
  padding: 8px 12px;
  align-items: center;
  border-radius: 8px;
  background-color: $color-background-base;

  &__name {
    color: $color-text-and-object-high-emphasis;
    font-size: 12px;
    font-weight: 700;
  }

  &__email {
    color: $color-text-and-object-high-emphasis;
    font-size: 12px;
  }

  &:hover {
    text-decoration: none;

    .link__name {
      color: $color-text-and-object-accent-primary;
    }
  }
}
</style>
